// A gzip file as fetched: unpacked in the browser (DecompressionStream),
// unless the server already took the gzip off (Content-Encoding). Shared by
// the star catalogues (src/stars.js), the asteroids and the city list.
export async function gunzipIfNeeded(buf) {
  const head = new Uint8Array(buf, 0, 2);
  // A server may already have taken the gzip off (Content-Encoding).
  if (head[0] !== 0x1f || head[1] !== 0x8b) return buf;
  if (typeof DecompressionStream === 'undefined') throw new Error('no DecompressionStream');
  const stream = new Blob([buf]).stream().pipeThrough(new DecompressionStream('gzip'));
  return new Response(stream).arrayBuffer();
}
